var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"indexPage"},[_c('main',{staticClass:"indexPage__main"},[_c('FormSignIn')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }